import { types } from 'mobx-state-tree';


const RELATIONSHIP_TYPES = {
    SPOUSE: 'spouse',
    COMMON_LAW: 'commonlaw',
    PARENT: 'parent',
    SIBLING: 'sibling',
    CHILD: 'child',
    OTHER: 'other',
};

const RelationshipTypeEnum = types.enumeration('RelationshipType', Object.values(RELATIONSHIP_TYPES));

export {
    RelationshipTypeEnum,
};
export default RELATIONSHIP_TYPES;
